import { SHOPIFY_APP_ID, SUPPLIER_CLIENT } from 'utils/constants/constants';

export const addShopifyStoreRequest = (shopName: string) => {
  const link = `https://${shopName}/admin/oauth/authorize?`;
  const clientId = `client_id=${SHOPIFY_APP_ID}`;
  // eslint-disable-next-line max-len
  const scope = '&scope=read_products,write_products,read_orders,write_orders,read_inventory,write_inventory,write_fulfillments';
  const redirectUri = `&redirect_uri=${SUPPLIER_CLIENT}/shopify_callback`;

  window.location.assign(`${link}${clientId}${scope}${redirectUri}`);
};
